import { Component } from '@angular/core';
import { CPatient } from '@models/imported/SagaSchema/CPatient';
import { CallcardComponentCard } from '../callcard-component-card';

@Component({
  selector: 'app-callcard-cpatients-card',
  templateUrl: './callcard-cpatients-card.component.html',
  styleUrls: ['./callcard-cpatients-card.component.scss']
})
export class CallcardCpatientsCardComponent extends CallcardComponentCard {
  patients: CPatient[];

  constructor() {
    super();
  }

  ngOnInit() {
    this.patients = this.callcard.component<CPatient>(CPatient);
  }
}
